<div class="d-flex jc-center">
  <div class="container-modal"
    [ngClass]="dataRecieved.status == 2 || dataRecieved.status == 14 || dataRecieved.status == 15 || dataRecieved.status == 16 || dataRecieved.status == 19 ? 'max-size':''">
    <div class="img-modal">
      <img [ngClass]="dataRecieved.status == 8 ? 'check' :''" [src]="currentModal?.img" alt="">
    </div>
    <div class="message">
      <h1>{{currentModal?.title}}</h1>
      <p [innerHTML]="currentModal?.description"></p>
    </div>
    <div *ngIf="dataRecieved.status == 2 || dataRecieved.status == 14 " class="aditional-info">
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-alert-modal">

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="col-status">Estado</th>
            <td mat-cell *matCellDef="let element" class="red-alert col-status">
              <p [ngClass]="element.error?.type != 6 ? '' :'circle' ">
                <ng-container *ngIf="element.error?.type != 6">
                  <span *ngIf="element.column; else lineOnly">ERROR CELDA {{ element.column }}{{ element.position }}</span>
                  <ng-template #lineOnly>ERROR FILA {{ element.position }}</ng-template>
                </ng-container>
                <ng-container *ngIf="element.error?.type == 6">
                  NO DISPONIBLE
                </ng-container>
              </p>
            </td>
          </ng-container>

          <!-- SKU Column (Dinamically Shown) -->
          <ng-container *ngIf="showSku" matColumnDef="sku">
            <th mat-header-cell *matHeaderCellDef class="col-sku">
              {{ type === 'form-way' ? 'Id form' :(type === 'seller-management' ? 'Vendedor' : 'SKU' )}}
            </th>
            <td mat-cell *matCellDef="let element" class="col-sku">
              {{ type === 'seller-management' || type === 'form-way' ? element[1] : element.sku || element[2] }}
            </td>
          </ng-container>

          <!-- Description Column (Dynamically Adjust Width) -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef class="col-description">Descripción</th>
            <td mat-cell *matCellDef="let element" class="text-message col-description">
              <p [innerHTML]="element.error?.type != 6 ? transform(element.error?.message) : element.description"></p>
            </td>
          </ng-container>

          <!-- Table Header Row and Data Rows -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    <div *ngIf="dataRecieved.status == 12" class="aditional-info">
      <div class="table-responsive">
        <div *ngFor="let element of data.skuError" class="content-table">
          <div class="red-alert">{{'ERROR LÍNEA ' + element.index}}</div>
          <div class="">{{element.sku}}</div>
          <div>{{element.error.message}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="dataRecieved.status == 13" class="aditional-info">
      <div class="table-responsive">
        <div class="">{{data.skuError[0]?.cabecera}}</div>
      </div>
    </div>
    <div *ngIf="dataRecieved.status == 16" class="aditional-info">
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-alert-modal">

          <!-- Column Header Column -->
          <ng-container matColumnDef="column">
            <th mat-header-cell *matHeaderCellDef class="col-column">Columna</th>
            <td mat-cell *matCellDef="let element" class="col-column red-alert">
              {{ element.column }}
            </td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef class="col-description">Descripción</th>
            <td mat-cell *matCellDef="let element" class="text-message col-description">
              {{ element.description }}
            </td>
          </ng-container>

          <!-- Table Header Row and Data Rows -->
          <tr mat-header-row *matHeaderRowDef="['column', 'description']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['column', 'description'];"></tr>
        </table>
      </div>
    </div>
    <div *ngIf="dataRecieved.status == 15" class="aditional-info">
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-alert-modal">

          <!-- Claim ID Column -->
          <ng-container matColumnDef="claimId">
            <th mat-header-cell *matHeaderCellDef class="col-claim-info">{{ dataRecieved.firstColumnLabel || 'ID Reclamo' }}</th>
            <td mat-cell *matCellDef="let element" class="col-claim-info">
              {{ element.claimId }}
            </td>
          </ng-container>

          <!-- Customer Code Column -->
          <ng-container matColumnDef="customerCode">
            <th mat-header-cell *matHeaderCellDef class="col-claim-info">Código Cliente</th>
            <td mat-cell *matCellDef="let element" class="col-claim-info">
              {{ element.customerCode }}
            </td>
          </ng-container>

          <!-- Reason Column -->
          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef class="col-reason">Razón</th>
            <td mat-cell *matCellDef="let element" class="text-message col-reason">
              {{ element.reason }}
            </td>
          </ng-container>

          <!-- Table Header Row and Data Rows -->
          <tr mat-header-row *matHeaderRowDef="['claimId', 'customerCode', 'reason']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['claimId', 'customerCode', 'reason'];"></tr>
        </table>
      </div>
    </div>
    <div *ngIf="dataRecieved.status == 19" class="aditional-info">
      <div class="table-responsive">
        <table mat-table [dataSource]="data.skuError" class="mat-elevation-z8 table-alert-modal">

          <!-- Item Column -->
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef class="col-column">Fila</th>
            <td mat-cell *matCellDef="let element" class="col-column red-alert">
              {{ element.position }}
            </td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef class="col-description">Descripción</th>
            <td mat-cell *matCellDef="let element" class="text-message col-description">
              {{ element.error.message }}
            </td>
          </ng-container>

          <!-- Table Header Row and Data Rows -->
          <tr mat-header-row *matHeaderRowDef="['item', 'description']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['item', 'description'];"></tr>

        </table>
      </div>
    </div>

  </div>
</div>